import ManageGroupsCtrl from './ManageGroupsCtrl';
import indexUrl from './index.html';
export default {
  controller: ManageGroupsCtrl,
  controllerAs: 'ctrl',
  templateUrl: indexUrl,
  bindings: {
    groupType: '@',
    disableBulkActions: '<?',
    simpleView: '<?',
  },
};
